import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { pageId: Number }
  
  connect() {
    // After turbo frame replacement, focus the toggle
    const toggleId = `toggle_${this.pageIdValue}`
    const toggle = document.getElementById(toggleId)
    if (toggle) {
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => {
        toggle.focus()
      }, 0)
    }
  }
}